import { ReactNode, createContext, useContext } from "react";
import { useFilterTransaction } from "./filter-transaction.hook";

const FilterTransactionContext = createContext(
  {} as ReturnType<typeof useFilterTransaction>
);
export function useFilterTransactionContext() {
  return useContext(FilterTransactionContext);
}

interface FilterTransactionProviderProps {
  children: ReactNode;
}
export function FilterTransactionProvider({
  children,
}: FilterTransactionProviderProps) {
  return (
    <FilterTransactionContext.Provider value={useFilterTransaction()}>
      {children}
    </FilterTransactionContext.Provider>
  );
}